"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var RatingIcon_1 = __importDefault(require("components/Icons/RatingIcon"));
var PREFIX = 'DealRating';
var classes = {
    ratingBox: "".concat(PREFIX, "-ratingBox"),
    serviceRating: "".concat(PREFIX, "-serviceRating"),
    serviceLightGrey: "".concat(PREFIX, "-serviceLightGrey"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.ratingBox)] = {
            display: 'flex',
            alignItems: 'center',
        },
        _b[".".concat(classes.serviceRating)] = {
            fontSize: theme.typography.fontSize,
            letterSpacing: '0.023em',
            color: theme.palette.text.secondary,
            paddingRight: '3px',
        },
        _b[".".concat(classes.serviceLightGrey)] = {
            color: theme.palette.grey[600],
            fontWeight: theme.typography.fontWeightLight,
            fontSize: theme.typography.fontSize,
        },
        _b);
});
var DealRating = function (_a) {
    var rating = _a.rating, ratingsCount = _a.ratingsCount;
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ className: classes.ratingBox }, { children: [(0, jsx_runtime_1.jsx)(RatingIcon_1.default, { rating: rating }), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.serviceRating }, { children: (rating === null || rating === void 0 ? void 0 : rating.toFixed(1)) || 'n/a' })), ratingsCount && (0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.serviceLightGrey }, { children: ["(", ratingsCount, ")"] }))] })));
};
exports.default = DealRating;
